import React, { useEffect, useState } from 'react';
import { SignIn } from './components/Login';
import ExNavbar from './components/NavbarExamine';
import { SelectRole } from './components/selectRole';
import { Staffbar } from './components/StaffBar';
import Navbar from './components/Navbar';
import { Spin } from 'antd';

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);
  const [isMultiplePos, setIsMultiplePos] = useState(false);



  // Check sessionStorage for user data after page load
  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    const storedRole = sessionStorage.getItem("role");
    const multiplePos = sessionStorage.getItem("IsMultiplePos") === 'yes';

    if (storedToken) {
      setToken(storedToken);
      setRole(storedRole);
      setIsMultiplePos(multiplePos);
    }

    setLoading(false); // Stop loading once the data is retrieved
  }, []);

  if (loading) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh', // full height of the viewport
    }}>
      <Spin size="large" />
    </div>;
  }

  if (!token) {
    return <SignIn />;
  }

  if (isMultiplePos) {
    return <SelectRole />;
  }

  switch (role) {
    case 'examiner':
      return <ExNavbar />;
    case 'staff':
      return <Staffbar />;
    case 'commitee':
      return <Staffbar />;
    default:
      return <Navbar />;
  }
};

export default App;
